/* Fabric Alex PDP description v2 — robust expand/collapse + semantic rich content */
(function () {
  'use strict';

  var rootLang = (document.documentElement.lang || 'en').toLowerCase();
  var isBg = rootLang.indexOf('bg') === 0;
  var copy = isBg ? {
    eyebrow: 'Детайли за продукта',
    title: 'Описание',
    subtitle: 'Материя, приложение и важни характеристики',
    more: 'Виж цялото описание',
    less: 'Покажи по-малко',
    specs: 'Характеристики'
  } : {
    eyebrow: 'Product details',
    title: 'Description',
    subtitle: 'Material, uses and important characteristics',
    more: 'Read full description',
    less: 'Show less',
    specs: 'Specifications'
  };

  function make(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof html === 'string') node.innerHTML = html;
    return node;
  }

  function isMostlyUppercase(text) {
    var letters = String(text || '').replace(/[^A-Za-zА-Яа-я]/g, '');
    if (letters.length < 8) return false;
    return letters === letters.toUpperCase();
  }

  function enhanceSpecs(content) {
    var table = content.querySelector('table');
    if (!table || table.closest('.fa-pdp-description__specs')) return;

    var wrapper = make('section', 'fa-pdp-description__specs');
    wrapper.setAttribute('aria-label', copy.specs);
    var heading = make('div', 'fa-pdp-description__specs-heading');
    heading.innerHTML = '<span class="fa-pdp-description__specs-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M5 6.5h14M5 12h14M5 17.5h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="8" cy="6.5" r="1.8" fill="currentColor"/><circle cx="15" cy="12" r="1.8" fill="currentColor"/><circle cx="10" cy="17.5" r="1.8" fill="currentColor"/></svg>' +
      '</span><strong>' + copy.specs + '</strong>';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(heading);
    wrapper.appendChild(table);
  }

  function enhanceNotice(content) {
    var first = content.querySelector('h1, h2, h3, p');
    if (first && isMostlyUppercase(first.textContent)) {
      first.classList.add('fa-pdp-description__notice');
    }
  }

  function enhance(item, index) {
    if (!item || item.getAttribute('data-fa-description-ready') === 'true') return;

    var card = item.querySelector('.card');
    var rte = item.querySelector('.rte');
    if (!card || !rte) return;

    item.setAttribute('data-fa-description-ready', 'true');
    item.classList.add('fa-pdp-description');
    card.classList.add('fa-pdp-description__card');

    rte.classList.remove('text--pull');
    rte.classList.add('fa-pdp-description__content');

    card.innerHTML = '';

    var header = make('header', 'fa-pdp-description__header');
    header.innerHTML =
      '<span class="fa-pdp-description__header-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 32 32" fill="none"><path d="M6.5 8.5h19v15h-19z" stroke="currentColor" stroke-width="2"/><path d="M10 12h12M10 16h9M10 20h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="m20.5 22.5 5-5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="24.7" cy="17.3" r="1.5" fill="currentColor"/></svg>' +
      '</span>' +
      '<span class="fa-pdp-description__header-copy">' +
        '<span class="fa-pdp-description__eyebrow">' + copy.eyebrow + '</span>' +
        '<strong class="fa-pdp-description__title">' + copy.title + '</strong>' +
        '<span class="fa-pdp-description__subtitle">' + copy.subtitle + '</span>' +
      '</span>';

    var bodyId = 'fa-product-description-' + index + '-' + Math.random().toString(36).slice(2, 7);
    var body = make('div', 'fa-pdp-description__body');
    body.id = bodyId;
    body.setAttribute('data-fa-description-body', '');
    body.setAttribute('aria-expanded', 'false');

    var contentWrap = make('div', 'fa-pdp-description__content-wrap');
    contentWrap.appendChild(rte);
    var fade = make('span', 'fa-pdp-description__fade');
    fade.setAttribute('aria-hidden', 'true');
    body.appendChild(contentWrap);
    body.appendChild(fade);

    var toggle = make('button', 'fa-pdp-description__toggle');
    toggle.type = 'button';
    toggle.setAttribute('data-fa-description-toggle', '');
    toggle.setAttribute('aria-controls', bodyId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span data-fa-description-toggle-text>' + copy.more + '</span>' +
      '<span class="fa-pdp-description__toggle-icon" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none"><path d="m5.5 7.5 4.5 4.5 4.5-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

    card.appendChild(header);
    card.appendChild(body);
    card.appendChild(toggle);

    enhanceNotice(rte);
    enhanceSpecs(rte);

    var expansionTimer;

    function previewHeight() {
      var raw = getComputedStyle(item).getPropertyValue('--fa-description-preview-height');
      var parsed = parseFloat(raw);
      return isFinite(parsed) && parsed > 100 ? parsed : 300;
    }

    function reduceMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function setCollapsed(animate) {
      window.clearTimeout(expansionTimer);
      var height = previewHeight();

      if (animate) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight;
      }

      item.classList.remove('is-expanded');
      body.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.querySelector('[data-fa-description-toggle-text]').textContent = copy.more;
      body.style.maxHeight = height + 'px';
    }

    function setExpanded() {
      window.clearTimeout(expansionTimer);
      item.classList.add('is-expanded');
      body.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.querySelector('[data-fa-description-toggle-text]').textContent = copy.less;

      if (reduceMotion()) {
        body.style.maxHeight = 'none';
        return;
      }

      body.style.maxHeight = body.scrollHeight + 'px';
      expansionTimer = window.setTimeout(function () {
        if (item.classList.contains('is-expanded')) {
          body.style.maxHeight = 'none';
        }
      }, 410);
    }

    function measure() {
      var height = previewHeight();

      if (rte.scrollHeight <= height + 36) {
        window.clearTimeout(expansionTimer);
        item.classList.add('is-short');
        item.classList.remove('is-expanded');
        body.style.maxHeight = 'none';
        body.setAttribute('aria-expanded', 'true');
        toggle.hidden = true;
      } else {
        item.classList.remove('is-short');
        toggle.hidden = false;
        if (item.classList.contains('is-expanded')) {
          body.style.maxHeight = 'none';
        } else {
          setCollapsed(false);
        }
      }
    }

    toggle.addEventListener('click', function () {
      var expanded = item.classList.contains('is-expanded');
      if (expanded) {
        setCollapsed(true);
        var top = item.getBoundingClientRect().top;
        if (top < 80) {
          window.scrollTo({
            top: window.pageYOffset + top - 92,
            behavior: reduceMotion() ? 'auto' : 'smooth'
          });
        }
      } else {
        setExpanded();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 100);
    }, { passive: true });

    requestAnimationFrame(function () {
      requestAnimationFrame(measure);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var items = context.querySelectorAll('.product-block-list__item--description');
    Array.prototype.forEach.call(items, function (item, index) {
      enhance(item, index);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
